import React, { useState } from "react";

function SecondaryButton({
  warning = false,
  startIcon,
  disabled = false,
  children,
  onClick,
  mobile = false,
  className,
}) {
  const baseClasses =
    "flex items-center font-light text-sm shadow-md border-shadow_25 bg-gray-100 border-1";
  const mobileClasses = mobile
    ? "px-4 py-2.5 rounded-full"
    : "px-3 py-1.5 rounded-lg";
  const textColorClasses = warning ? "text-red-600" : "text-black";
  const shadowClasses =
    "shadow-[0px_1px_5px_rgba(0,0,0,0.2)] hover:shadow-[0px_1px_5px_rgba(0,0,0,0.3)]";
  const hoverClasses = "hover:bg-gray-100";
  const disabledClasses = disabled
    ? "opacity-50 cursor-not-allowed"
    : "cursor-pointer";
  const minWidthClass = "min-w-[10px]";

  const buttonClasses = `${baseClasses} ${mobileClasses} ${textColorClasses} ${shadowClasses} ${hoverClasses} ${disabledClasses} ${minWidthClass} ${
    className || ""
  }`;

  const handleClick = (e) => {
    if (onClick) onClick(e);
  };

  return (
    <button disabled={disabled} className={buttonClasses} onClick={handleClick}>
      <div className="flex flex-row gap-2 items-center">
        {startIcon}
        {children}
      </div>
    </button>
  );
}

export default SecondaryButton;
